import { Link } from 'react-router-dom';
import { useState } from 'react';

const LOGO_LIGHT = '/images/brand-partners-logo.png';
const LOGO_DARK  = '/images/brand-partners-logo-reversed.png';

/**
 * Official Brand Partners logo (from bp.agency).
 * Uses the production PNG; falls back to an inline SVG wordmark if the asset fails to load.
 */
export default function Logo({ size = 'md', mono = false, className = '' }) {
  const heights = { sm: 32, md: 40, lg: 56 };
  const h = heights[size] || 40;
  const [failed, setFailed] = useState(false);

  return (
    <Link
      to="/"
      data-testid="logo"
      aria-label="Brand Partners - Home"
      className={`inline-flex items-center shrink-0 ${className}`}
      style={{ minWidth: h * 4.2, height: h }}
    >
      {!failed ? (
        <img
          src={mono ? LOGO_DARK : LOGO_LIGHT}
          alt="Brand Partners - Award-Winning Digital Agency"
          width={h * 4.2}
          height={h}
          onError={() => setFailed(true)}
          style={{ height: `${h}px`, width: 'auto', display: 'block', objectFit: 'contain' }}
          loading="eager"
          decoding="async"
        />
      ) : (
        <FallbackMark height={h} mono={mono} />
      )}
    </Link>
  );
}

function FallbackMark({ height, mono }) {
  // Inline SVG matching the Brand Partners look - colored ascending bars + wordmark + tagline
  const ink = mono ? '#FFFFFF' : '#0F172A';
  const tag = mono ? 'rgba(255,255,255,0.7)' : '#64748B';
  const blue = '#0072EE';
  const teal = '#14B8A6';
  const amber = '#F59E0B';
  const coral = '#FB6A48';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 240 56"
      height={height}
      width={height * 4.2}
      role="img"
      aria-label="Brand Partners - Award-Winning Digital Agency"
      style={{ display: 'block' }}
    >
      {/* Mark */}
      <g>
        <rect x="2"  y="32" width="6" height="20" rx="2" fill={coral} />
        <rect x="11" y="22" width="6" height="30" rx="2" fill={amber} />
        <rect x="20" y="14" width="6" height="38" rx="2" fill={teal} />
        <rect x="29" y="4"  width="6" height="48" rx="2" fill={blue} />
      </g>
      {/* Wordmark */}
      <text x="46" y="30" fontFamily="Outfit, system-ui, sans-serif" fontWeight="800" fontSize="22" letterSpacing="-0.5" fill={ink}>
        Brand<tspan fill={blue}>Partners</tspan>
      </text>
      <text x="46" y="46" fontFamily="Outfit, system-ui, sans-serif" fontWeight="600" fontSize="8" letterSpacing="2.6" fill={tag}>
        AWARD-WINNING DIGITAL AGENCY
      </text>
    </svg>
  );
}
